import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {FourDService} from '4d-mapper';
import {ActivatedRoute, Router} from '@angular/router';
import {StripeService} from 'ngx-stripe';
import {AppService} from '../../../commons/app.service';
import {TranslateService} from '@ngx-translate/core';
import {AppBaseComponent} from '../../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../../xs/services/events/application-events.service';

@Component({
  selector: 'app-photogram-estimate-price',
  templateUrl: './photogram-estimate-price-dialog.component.html',
  styleUrls: ['./photogram-estimate-price-dialog.component.scss']
})
export class PhotogramEstimatePriceDialog extends AppBaseComponent implements AfterViewInit, OnInit {
  estimatedPrice: any = 0;
  noOfImages: number;
  megapixel: number = 20;
  doSparse: boolean = true;
  doOrtho: boolean;
  doDense: boolean;
  doMesh: boolean;
  doDEM: boolean;

  constructor(
    public dialogRef: MatDialogRef<PhotogramEstimatePriceDialog>, @Inject(MAT_DIALOG_DATA) public data: any
    , public fourD: FourDService, public service: AppService, public router: Router,
    public snackBar: MatSnackBar, public dialog: MatDialog, private activeRoute: ActivatedRoute,
    public translate: TranslateService,
    private stripeService: StripeService,
    private fb: FormBuilder, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);

  }

  ngAfterViewInit(): void {
  }

  calculatePrice() {

    try{
      this.estimatedPrice = 0;
      if(this.megapixel && this.noOfImages){
        let price = 0;
        if(this.doMesh || (this.doOrtho && this.doDense && this.doMesh && this.doDEM) || (this.doDense && this.doOrtho && this.doMesh)){
          price = 10;
        }else if((this.doDense && this.doOrtho) || (this.doDense && this.doDEM) || (this.doOrtho && this.doDEM) || (this.doDense && this.doDEM && this.doOrtho)){
          price = 5;
        }else if (this.doOrtho || this.doDEM || this.doDense){
          price = 5;
        }else if (this.doSparse){
          price = 3;
        }
        this.estimatedPrice = (this.megapixel * this.noOfImages / 1000 * price).toFixed(2);
        if(this.estimatedPrice < 25){
          this.estimatedPrice = 25;
        }
      }
    }catch (e) {
      this.estimatedPrice = 'Error'
    }
  }
}
